module.exports = __webpack_public_path__ + "static/media/cha3.8770ee7d.wav";